import * as qs from 'qs';

const paramsSerializer = params =>
  qs.stringify(params, {
    skipNulls: true,
    arrayFormat: 'repeat',
    sort: (a, b) => a.localeCompare(b),
  });

export default paramsSerializer;
